import React from "react";

function LoadingDots() {
  return (
    <div className="loading-container">
      <div className="loading-dot"></div>
      <div className="loading-dot"></div>
      <div className="loading-dot"></div>
    </div>
  );
}

export default LoadingDots;
